import { defineStore } from "pinia"
import { AuthSecureStorage, type IAuthToken, type IAuthTokenDecoded } from "./authSecureStorage"
import { EAuthStage } from "./model"


const authStorageManager = new AuthSecureStorage(import.meta.env.VITE_APP_PREFIX)

export const useAuthStore = defineStore("auth", {
    state: () => ({
        phone: "",
        authToken: {} as IAuthToken | null,
        decodedToken: {} as IAuthTokenDecoded | null
    }),
    getters: {
        getAuthStage(state): EAuthStage {
            if (state.phone !== "")
                return EAuthStage.Code
            else
                return EAuthStage.NotStarted
        },
        isAuthenticated(state): boolean {
            return state.authToken !== null && !!state.authToken.token && state.authToken.token !== ""
        }
    },
    actions: {
        async init() {
            if (!this.authToken?.token) {
                this.authToken = await authStorageManager.get()
                this.decodedToken = authStorageManager.decode(this.authToken)
            }
        },
        postAuth(): void {
            this.phone = ""
        },
        logout() {
            this.authToken = {
                token: "",
                expirationTimestamp: 0
            }
            this.phone = ""
            this.decodedToken = null
            this.$reset()
        }
    }
})
